import React from 'react';
import { useSelector } from 'react-redux';
import { LinearProgress } from '@material-ui/core';

import { useSearchNonprofitsQuery } from 'generated/graphql';
import { gray2 } from 'utils/color-styles';
import { getAppDomain } from 'utils/getAppDomain';
import ExternalLinkIcon from 'assets/icons/external-link.svg';
import { selectOrganization, selectUser } from 'entities/user/selectors';
import Img from 'retired/Img';
import { renderAddress } from 'utils/renderAddress';

const NonprofitsList = ({ nonprofitName }: { nonprofitName: string }) => {
  const organization = useSelector(selectOrganization);
  const user = useSelector(selectUser);

  const { data, loading } = useSearchNonprofitsQuery({
    variables: {
      searchTerm: nonprofitName,
      countryCode: 'US',
    },
  });

  if (loading) {
    return <LinearProgress />;
  }

  const nonprofits = data?.searchNonprofits || [];

  return (
    <>
      <h3 style={{ margin: 0, marginBottom: 12 }}>Similar nonprofits</h3>

      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {nonprofits.map(({ name, id, ein, locationObject }) => (
          <div key={id} style={{ marginBottom: 12 }}>
            {name}

            <div
              style={{
                color: gray2,
                fontSize: 12,
                margin: 0,
              }}
            >
              <div style={{ display: 'flex' }}>
                {`(ein: ${ein}, id: ${id})`}
                <a
                  style={{
                    display: 'inline-block',
                  }}
                  target="_blank"
                  href={`${getAppDomain([organization, user])}/organization/${id}`}
                >
                  <Img
                    alt="External Link"
                    src={ExternalLinkIcon}
                    style={{
                      width: 12,
                      height: 12,
                      marginLeft: 5,
                    }}
                  />
                </a>
              </div>
              {renderAddress(locationObject)}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default NonprofitsList;
